import 'bootstrap/dist/css/bootstrap.min.css';
import { StyledButton } from '../StyledButton';
import styled from 'styled-components';
export const StyledIconButton = styled(StyledButton) `
  border: unset;
  background: transparent;
  color: #2b2828;
  &:hover {
    background: #ffffff;
    color: #2b2828;
    border-radius: 6px;
    border: solid 1px #caccd4;
  }
  padding: 10px;
  margin: 10px;
  min-width: 30px;
  min-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: unset;
`;
//# sourceMappingURL=index.js.map